module.exports = "img/zoom.710afe1.png";